import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { FormGroup, FormBuilder, Validators, AbstractControl, FormArray } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  imageProcessing,
  ImageSnippet,
} from "src/app/utils/image-processing-utils";
import * as moment from 'moment-timezone';
import { getAddressDetails, nonZeroCoordinateValidator } from "src/app/utils/utils.common";
import { sweetAlert } from "src/app/utils/swal";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { LevelOfServiceService } from "../../../service/level-of-service/level-of-service.service";
import { TRIPREASONLIST } from "src/app/utils/utils.common";
import { forkJoin } from "rxjs";
import { SharedDataService } from "src/app/service/shared-service/shared-data.service";
import { CorporateService } from "src/app/service/corporate-service/corporate-service";
import { MemberService } from "src/app/service/member-service/member.service";
import { AssigTripsService } from "src/app/service/assigntrips-service/assigntrips-service";
@Component({
  selector: "app-create-member",
  templateUrl: "./create-member.component.html",
  styleUrls: ["./create-member.component.css"],
})
export class CreateMemberComponent implements OnInit, OnDestroy {
  @Input() source?: string;
  @Input() memberEditId?
  @Output() onSave = new EventEmitter<string>();
  @Output() onCloseModal = new EventEmitter<string>();
  memberForm: FormGroup;
  commentForm: FormGroup;
  user;
  tripReasonList = TRIPREASONLIST;
  submitted = false;
  cmtSubmitted = false;
  submittedFile = false;
  selectedFile: ImageSnippet = null;
  memberId;
  corporateUsers = [];
  status = "active";
  spaceTypes = [];
  levelOfServices = [];
  spaceTypeMainList = [];


  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private sharedDataService : SharedDataService,
    private assignTripService: AssigTripsService,
    private router: Router,
    private memberService: MemberService,
    private corporateService: CorporateService,
  ) {
  }

  ngOnInit() {

    if (this.activatedRoute.snapshot.url.length === 4 && this.activatedRoute.snapshot.url[3].path === 'edit') {
      this.memberId = this.activatedRoute.snapshot.url[2].path;

 
    }
    if(this.memberEditId){
      this.memberId = this.memberEditId
    }

    this.memberForm = this.fb.group({
      employeeId: [""],
      firstName: ["", Validators.required],
      middleName: [""],
      lastName: ["", Validators.required],
      email: [""],
      clientId: ["",],
      preDob: [""],
      dob: [""],
      contactNumber: [""],
      cellPhone: [""],
      los: [""],
      spaceType: [""],
      fundingSource: [""],
      gender: [""],
      weight: [""],
      stairsStep: [""],
      covidStatus: ["negative"],
      privateNote: [""],
      note: [""],
      clientType : ["patient"],
      password: [''],
      smsConsent: [false],

      statusDetails: this.fb.group({
        preExpiryDate: [''],
        expiryDate: [""],
        reason: [""],
      }),

      type: ["regular"],
      preVipExpiryDate: [''],
      vipExpiryDate: [""],
      homeAddress: this.fb.group({
        name: [""],
        address: ["", Validators.required],
        aptOrSuite: [""],
        zipCode: [""],
        state: [""],
        city: [""],
        latitude: [0, nonZeroCoordinateValidator()],
        longitude: [0, nonZeroCoordinateValidator()]
      }),
      profileImageURL : [""],
      accountStatus: ["active", Validators.required],
      history: [[]]
    });

    this.commentForm = this.fb.group({
      text:['', Validators.required],
      createdAt: [''],
      createdBy:[''],
      relation:['']
    })

    this.memberForm.controls.los.valueChanges.subscribe(value => {
      if (value) {
        this.memberForm.get('spaceType').setValidators([Validators.required]);
      } else {
        this.memberForm.get("spaceType").clearValidators();
      }
      this.memberForm.get('spaceType').updateValueAndValidity();
    });

    this.makeCompulsoryCalls();
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;

        this.commentForm.patchValue({
          createdBy:this.user.displayName,
        })
        this.memberForm.patchValue({
          fundingSource: this.user.cooperate ? this.user.cooperate._id : this.user._id
        })
          }
        if (this.memberId) {
          this.getMember(this.memberId);
        }
      });
  }

  makeCompulsoryCalls() {
    const requests = [
      this.getFundingSourceList(),
      this.getConfigurations()


    ];

    // Make all requests in parallel
    forkJoin(requests).subscribe(
      ([res1,res2]) => {

        if (res1) {
          this.corporateUsers = res1;
        }
        if (res2) {
          this.levelOfServices = res2.levelofservices;
          this.spaceTypeMainList = res2.spacetypes;
        }
      },
      error => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }

  onChangeAccountStatus(value) {
      if (value === 'inactive') {
        this.memberForm.controls.statusDetails.get('reason').setValidators([Validators.required]);
      } else {
        this.memberForm.controls.statusDetails.get('reason').clearValidators();
      }
      this.memberForm.controls.statusDetails.get('reason').updateValueAndValidity();
  }

  onChangeReason(value) {
      if (value === 'expired') {
        this.memberForm.controls.statusDetails.get('expiryDate').setValidators([Validators.required]);
      } else {
        this.memberForm.controls.statusDetails.get("expiryDate").clearValidators();
      }
      this.memberForm.controls.statusDetails.get('expiryDate').updateValueAndValidity();
  }

  onChangeType(value) {
    if (value === 'vip'){
      this.memberForm.get('vipExpiryDate').setValidators([Validators.required]);
    }
    else {
      this.memberForm.get("vipExpiryDate").clearValidators();
    }
    this.memberForm.get('vipExpiryDate').updateValueAndValidity();
  }

  onChangeClientType(value){
    if (value === 'passenger') {
      this.memberForm.get('email').setValidators([Validators.required]);
      this.memberForm.get('password').setValidators([Validators.required]);
    } else {
      this.memberForm.get('email').clearValidators();
      this.memberForm.get('password').clearValidators();
    }
    this.memberForm.get('email').updateValueAndValidity();
    this.memberForm.get('password').updateValueAndValidity();
  }

  getMember(memberId) {
    this.memberService
      .getMemberById(memberId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.memberForm.patchValue({
            ...data,
            password: '',
            preDob: moment(data.dob),
            dob: data.dob,
          });

          if (data.statusDetails && data.statusDetails.reason === 'expired') {
            this.memberForm.patchValue({
              statusDetails: {
                ...data.statusDetails,
                preExpiryDate: data.statusDetails.expiryDate
              }
            });
          }

          if (data.type && data.type === 'vip'){
            this.memberForm.patchValue({
                ...data,
                preVipExpiryDate: data.vipExpiryDate
            });
          }
          this.onSelectSpaceType(data.spaceType);
        }
      });
  }

  saveMember() {
    console.log("FormGroup", this.memberForm)
    console.log("FormGroup Value", this.memberForm.value)
    this.submitted = true;

    if (this.memberForm.invalid) {
      return;
    }
    const payload = this.memberForm.value
    if (payload.accountStatus === 'active') {
      delete payload.statusDetails;
    }

    if (payload.clientType === 'patient' || !payload.password) {
      delete payload.password;
    }

    if (payload.accountStatus === 'inactive' &&  payload.statusDetails.reason != 'expired') {
      delete payload.statusDetails.expiryDate;
    }

    if (payload.type &&  payload.type != 'vip') {
      delete payload.vipExpiryDate;
    }

    if (!payload.type) {
      delete payload.type;
    }

    if (!payload.spaceType) {
      delete payload.spaceType ;
    }

    if (!payload.los) {
      delete payload.los;
    }

    if (!payload.email ) {
      delete payload.email;
    }

    if (!payload.fundingSource) {
      delete payload.fundingSource;
    }

    this.callMemberApi(payload);
  }

  callMemberApi(payload, isFromHistory?) {
    this.memberService
    .saveMember(this.memberId, payload)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(data => {
      if (data) {
        if (this.source === 'modal') {
          this.onSave.emit(data);
          this.onCloseModal.emit();
        } else {
          if (isFromHistory) {
            this.memberForm.patchValue({
              history: data.history
            })
            this.commentForm.reset();
            this.cmtSubmitted = false;
          } else {
            this.router.navigateByUrl('credentialing/members');
          }
        }
      }
    }, err => {
      sweetAlert('Error', err, 'warning', 'OK');
    });
  }


  onDateChange(evt, control: AbstractControl) {
    if (evt) {
      control.setValue(moment(evt).toISOString());
    }
  }

  setAddress(place) {
    const addressDetails = place ? getAddressDetails(place) : undefined;
    this.memberForm.patchValue({
      homeAddress: {
        address: place.formatted_address,
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng(),
        ...addressDetails

      }
    });
  }

  getFundingSourceList() {

    return this.corporateService.getCorporateUsers('active');
  }
  addComment() {
    this.cmtSubmitted = true;
    if (this.commentForm.invalid) {
      return;
    }

    const newComment = { ...this.commentForm.value, createdAt: moment().tz(this.user.timeZone).toISOString() };
    if (this.commentForm.value.relation) {
      this.callMemberApi({ history: [...this.memberForm.value.history, newComment] }, true);
    } else {
      this.callMemberApi({ history: [...this.memberForm.value.history, newComment] }, true);
    }

  }

  trimId(str) {
    if(str){
      return str.substring(str.length-8, str.length);
    }
  }

  cancelReply(){
    this.commentForm.reset();
  }

  onCommentEdit(comment) {
    this.commentForm.patchValue({
      ...comment,
      relation: comment._id,
      createdBy: this.user.displayName

    })
  }

  onSelectSpaceType(event) {
    const selectedSpaceType = this.spaceTypeMainList.find(spaceType => spaceType._id === event);
    if (selectedSpaceType) {
      this.memberForm.patchValue({ los: selectedSpaceType.los });
    }
  }

getConfigurations() {
  return this.assignTripService.getConfigurations({status: 'active'})
}

async fileProcessing(ImageInput, form) {
 
}

  get form() {
    return this.memberForm.controls;
  }

  get addressForm() {
    return this.memberForm.controls.homeAddress['controls'];
  }

  get statusForm() {
    return this.memberForm.controls.statusDetails['controls'];
  }

  get historyForm() {
    return this.commentForm.controls;
  }

  ngOnDestroy(): void {
  }
}
